module.exports = __webpack_public_path__ + "media/images/homes/set-67891188470083014e7a5dde44756150.png";